/**
 * ts-contact-valid.js — Validation & UX du formulaire Contactez-nous
 * Reprend le même pattern que ts-valid-data.js + ts-form-ux.js.
 * Champs : contactform-name, contactform-phone (optionnel), contactform-email, contactform-message
 */
document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("template-contactform");
  const submitBtn = document.getElementById("contactform-submit");
  const nameInput = document.getElementById("contactform-name");
  const phoneInput = document.getElementById("contactform-phone");
  const emailInput = document.getElementById("contactform-email");
  const messageInput = document.getElementById("contactform-message");

  if (!form) return;

  const submitBtnOriginalHTML = submitBtn ? submitBtn.innerHTML : "";

  // ── Utilitaires de validation ──────────────────────────────────────────

  function validatePhone(val) {
    const digits = val.replace(/\D/g, "");
    return digits === "" || /^\d{10}$/.test(digits) || /^\d{11}$/.test(digits);
  }

  function validateEmail(val) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
  }

  function showError(input, msg, spanId) {
    let span = document.getElementById(spanId);
    if (!span) {
      span = document.createElement("span");
      span.id = spanId;
      span.className = "error-message";
      input.parentNode.appendChild(span);
    }
    if (msg) {
      span.textContent = msg;
      span.style.display = "block";
      input.classList.add("input-error");
    } else {
      span.textContent = "";
      span.style.display = "none";
      input.classList.remove("input-error");
    }
  }

  function scrollToFirstError() {
    const first = form.querySelector(".input-error");
    if (first) {
      first.scrollIntoView({ behavior: "smooth", block: "center" });
      first.focus({ preventScroll: true });
    }
  }

  function setLoading(loading) {
    if (!submitBtn) return;
    submitBtn.disabled = loading;
    submitBtn.innerHTML = loading
      ? '<span class="ts-btn-spinner"></span> Envoi en cours...'
      : submitBtnOriginalHTML;
  }

  // ── Formatage automatique du téléphone ────────────────────────────────

  if (phoneInput) {
    function formatPhone(raw) {
      let digits = raw.replace(/\D/g, "");
      if (digits.length === 11 && digits.charAt(0) === "1")
        digits = digits.slice(1);
      digits = digits.substring(0, 10);
      if (digits.length >= 7)
        return (
          "(" +
          digits.slice(0, 3) +
          ") " +
          digits.slice(3, 6) +
          "-" +
          digits.slice(6)
        );
      else if (digits.length >= 4)
        return "(" + digits.slice(0, 3) + ") " + digits.slice(3);
      else if (digits.length > 0) return "(" + digits;
      return "";
    }

    phoneInput.addEventListener("input", function () {
      const cursorPos = this.selectionStart;
      const oldValue = this.value;
      let digitsBeforeCursor = 0;
      for (let i = 0; i < cursorPos; i++) {
        if (/\d/.test(oldValue[i])) digitsBeforeCursor++;
      }
      const formatted = formatPhone(oldValue);
      this.value = formatted;
      let count = 0,
        newPos = formatted.length;
      for (let i = 0; i < formatted.length; i++) {
        if (/\d/.test(formatted[i])) count++;
        if (count === digitsBeforeCursor) {
          newPos = i + 1;
          break;
        }
      }
      try {
        this.setSelectionRange(newPos, newPos);
      } catch (e) {}
      // Validation temps réel
      if (this.value && !validatePhone(this.value)) {
        showError(
          this,
          "❌ Numéro invalide — ex : (581) 688-3773",
          "contactform-phone-error",
        );
      } else {
        showError(this, "", "contactform-phone-error");
      }
    });

    phoneInput.addEventListener("change", function () {
      this.value = formatPhone(this.value);
    });
  }

  // ── Validation temps réel ─────────────────────────────────────────────

  if (nameInput) {
    nameInput.addEventListener("blur", function () {
      if (!this.value.trim()) {
        showError(
          this,
          "❌ Ce champ est obligatoire.",
          "contactform-name-error",
        );
      } else {
        showError(this, "", "contactform-name-error");
      }
    });
    nameInput.addEventListener("input", function () {
      if (this.value.trim()) showError(this, "", "contactform-name-error");
    });
  }

  if (emailInput) {
    emailInput.addEventListener("input", function () {
      if (!this.value.trim()) {
        showError(this, "", "contactform-email-error");
      } else if (!validateEmail(this.value)) {
        showError(
          this,
          "❌ Adresse courriel invalide.",
          "contactform-email-error",
        );
      } else {
        showError(this, "", "contactform-email-error");
      }
    });
  }

  if (messageInput) {
    messageInput.addEventListener("blur", function () {
      if (!this.value.trim()) {
        showError(
          this,
          "❌ Ce champ est obligatoire.",
          "contactform-message-error",
        );
      } else {
        showError(this, "", "contactform-message-error");
      }
    });
    messageInput.addEventListener("input", function () {
      if (this.value.trim()) showError(this, "", "contactform-message-error");
    });
  }

  // ── Compteur de caractères pour le message ────────────────────────────

  if (messageInput) {
    const MAX_CHARS = 500;
    messageInput.setAttribute("maxlength", MAX_CHARS);
    const counter = document.createElement("div");
    counter.className = "ts-char-counter";
    counter.textContent = "0 / " + MAX_CHARS;
    messageInput.parentNode.insertBefore(counter, messageInput.nextSibling);
    messageInput.addEventListener("input", function () {
      const len = this.value.length;
      counter.textContent = len + " / " + MAX_CHARS;
      counter.classList.toggle("ts-char-counter--warn", len > MAX_CHARS * 0.85);
    });
  }

  // ── Validation à la soumission ────────────────────────────────────────

  form.addEventListener(
    "submit",
    function (event) {
      let hasErrors = false;

      // Nom
      if (nameInput && !nameInput.value.trim()) {
        showError(
          nameInput,
          "❌ Ce champ est obligatoire.",
          "contactform-name-error",
        );
        hasErrors = true;
      }

      // Téléphone (optionnel mais formaté)
      if (phoneInput && phoneInput.value && !validatePhone(phoneInput.value)) {
        showError(
          phoneInput,
          "❌ Numéro invalide — ex : (581) 688-3773",
          "contactform-phone-error",
        );
        hasErrors = true;
      }

      // Courriel
      if (emailInput && !validateEmail(emailInput.value.trim())) {
        showError(
          emailInput,
          "❌ Adresse courriel invalide.",
          "contactform-email-error",
        );
        hasErrors = true;
      }

      // Message
      if (messageInput && !messageInput.value.trim()) {
        showError(
          messageInput,
          "❌ Ce champ est obligatoire.",
          "contactform-message-error",
        );
        hasErrors = true;
      }

      if (hasErrors) {
        event.preventDefault();
        event.stopImmediatePropagation();
        scrollToFirstError();
        return;
      }

      // Tout est valide — on intercepte et on envoie via fetch
      event.preventDefault();
      event.stopImmediatePropagation();

      var turnstileInput = document.querySelector(
        '[name="cf-turnstile-response"]',
      );
      var turnstileError = document.getElementById(
        "contactform-turnstile-error",
      );
      if (!turnstileInput || !turnstileInput.value.trim()) {
        if (turnstileError) {
          turnstileError.textContent =
            "❌ Veuillez compléter la vérification anti-robot.";
          turnstileError.style.display = "block";
          turnstileError.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        } else {
          alert("Veuillez compléter la vérification de sécurité.");
        }
        setLoading(false);
        return;
      }
      if (turnstileError) {
        turnstileError.style.display = "none";
      }
      var turnstileToken = { value: turnstileInput.value.trim() };

      setLoading(true);

      // Génère un event_id unique partagé entre le pixel browser et le CAPI serveur.
      // Le serveur (contact-send.php) recevra cet ID et l'utilisera pour Meta CAPI.
      // Meta déduplique automatiquement les deux signaux grâce à cet ID.
      var leadEventId =
        "lead_contact_" +
        Date.now() +
        "_" +
        Math.random().toString(36).slice(2, 9);

      function getCookie(name) {
        var m = document.cookie.match("(^|;)\\s*" + name + "=([^;]+)");
        return m ? m[2] : "";
      }

      var payload = {
        name: nameInput ? nameInput.value.trim() : "",
        phone: phoneInput ? phoneInput.value.trim() : "",
        email: emailInput ? emailInput.value.trim() : "",
        message: messageInput ? messageInput.value.trim() : "",
        turnstileToken: turnstileToken.value,
        leadEventId: leadEventId,
        fbc: getCookie("_fbc"),
        fbp: getCookie("_fbp"),
      };

      fetch("/include/contact-send.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          if (data.success) {
            // Pixel browser Contact — même event_id que le CAPI serveur → Meta déduplique
            // On utilise «Contact» (et non «Lead») pour distinguer le formulaire de contact
            // du formulaire d'estimation (Lead = intention forte, Contact = signal informatif).
            if (typeof fbq === "function") {
              fbq(
                "track",
                "Contact",
                { content_name: "contact-form" },
                { eventID: leadEventId },
              );
            }

            // Google Ads / GA4 — génère une conversion "generate_lead"
            if (typeof gtag === "function") {
              gtag("event", "generate_lead", {
                event_category: "formulaire",
                event_label: "contact",
              });
            }

            // Remplacer le formulaire par un message de confirmation
            var wrap = document.querySelector(".ts-contact-form-wrap");
            if (wrap) {
              wrap.innerHTML =
                '<div style="text-align:center;padding:48px 20px;">' +
                '<div style="display:inline-flex;align-items:center;justify-content:center;width:72px;height:72px;border-radius:50%;background:rgba(24,147,207,0.12);margin-bottom:24px;">' +
                '<i class="fa-solid fa-circle-check" style="font-size:2rem;color:#1893cf;"></i>' +
                "</div>" +
                '<h2 style="font-size:1.5rem;font-weight:700;color:#0f1923;margin-bottom:10px;">Message envoyé !</h2>' +
                '<p style="color:#6b7a8d;font-size:0.95rem;max-width:380px;margin:0 auto 28px;">Merci de nous avoir contactés. Notre équipe vous répondra sous 24h.</p>' +
                '<a href="/" style="display:inline-flex;align-items:center;gap:8px;background:#1893cf;color:#fff;text-decoration:none;font-weight:700;font-size:0.9rem;padding:12px 26px;border-radius:50px;">' +
                '<i class="fa-solid fa-house"></i> Retour à l\'accueil' +
                "</a>" +
                "</div>";
            }
          } else {
            alert(
              "❌ " +
                (data.error ||
                  "Erreur lors de l'envoi. Veuillez nous appeler au (581) 688-3773."),
            );
            setLoading(false);
          }
        })
        .catch(function () {
          alert(
            "❌ Problème de connexion. Veuillez réessayer ou nous appeler au (581) 688-3773.",
          );
          setLoading(false);
        });
    },
    true,
  ); // capture phase
});
